import { IDistrict } from 'app/shared/model/district.model';

export interface ICountry {
  id?: string;
  name?: string;
  districts?: IDistrict[];
}

export const defaultValue: Readonly<ICountry> = {};
